import currencyReducer from "./currencyReducer";
import productReducer from "./productReducer";
import cartReducer from "./cartReducer";
import wishlistReducer from "./wishlistReducer";
import compareReducer from "./compareReducer";
import authReducer from "./authReducer";
import chatReducer from "./chatReducer";
import { combineReducers } from "redux";
import { createMultilanguageReducer } from "redux-multilanguage";
import products from "./../../data/products.json";

const rootReducer = combineReducers({
  multilanguage: createMultilanguageReducer({ currentLanguageCode: "en" }),
  currencyData: currencyReducer,
  productData: productReducer(products),
  cartData: cartReducer,
  wishlistData: wishlistReducer,
  compareData: compareReducer,
  authData: authReducer,
  chatData: chatReducer
});

export default rootReducer;
